import options from './__generated__';

export const shouldShowSubscribeForm = options['showSubscribeForm'];
export const sectionQuoteProps = options['sectionQuoteProps'];
export const sectionQuoteImageProps = options['sectionQuoteImageProps'];
export const componentsToExclude = options['componentsToExclude'];
export const storeFinderVariant = options['storeFinderVariant'];
export const specialQuoteCarousel = options['specialQuoteCarousel'];
export const accountContactInformationType = options['accountContactInformationType'];
export const seoConfig = options['seoConfig'];
export const contactInfoConfig = options['contactInfoConfig'];
export const heroVariant = options['heroVariant'];
export const jobsReferralLink = options['jobsReferralLink'];
export const showJobPages = options['showJobPages'];
export const showNewsPages = options['showNewsPages'];
